// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Insights {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.Insights__volume_history_title,
.Insights__conversion_history_title {
  background-color: var(--palette-whipe);
  padding: 4px 7px;
  font-family: Roboto;
  font-size: 0.79rem;
  line-height: 1.82;
  color: var(--palette-text);
  margin: 7px 0px;
}

.Insights__volume_history,
.Insights__conversion_history {
  display: flex;
  justify-content: space-between;
}

.Insights__cpc_history,
.Insights__clicks_history {
  flex-direction: column;
}

.Insights__cpc_history {
  flex: 2;
}

.Insights__clicks_history {
  flex: 1;
}

.Insights__conversion_history {
  display: flex;
}

.Insights__conversion_rate,
.Insights__average_cpa,
.Insights__conversions {
  flex-direction: column;
  flex: 1;
}

.Insights__title {
  font-family: "Roboto";
  font-size: 0.79rem;
  line-height: 1.82;
  color: var(--palette-gray-8);
}

.Insights__value {
  font-family: "Roboto";
  font-size: 0.93rem;
  line-height: 1.5;
  color: var(--palette-text);
}

.Insights__install_pixel {
  margin-top: 10px;
  font-size: 0.79rem;
}

.Insights__main_description {
  font-family: "Roboto";
  font-size: 1rem;
  line-height: 1.43;
  color: var(--palette-gray-8);
}

.Insights__segmentation_container {
  border-right: 1px solid var(--palette-disabled);
}

.Insights__install_pixel a {
  color: var(--palette-trovit-blue);
}

.Insights .Insights__volume_history_title,
.Insights .Insights__conversion_history_title {
  background-color: var(--palette-whipe);
  padding: 4px 7px;
  font-family: Roboto;
  font-size: 0.79rem;
  line-height: 1.82;
  color: var(--palette-text);
  margin: 7px 0px;
}

.Insights .Insights__volume_history,
.Insights .Insights__conversion_history {
  display: flex;
  justify-content: space-between;
}

.Insights .Insights__cpc_history,
.Insights .Insights__clicks_history {
  flex-direction: column;
}

.Insights .Insights__cpc_history {
  flex: 2;
}

.Insights .Insights__clicks_history {
  flex: 1;
}

.Insights .Insights__conversion_history {
  display: flex;
}

.Insights .Insights__conversion_rate,
.Insights .Insights__average_cpa,
.Insights .Insights__conversions {
  flex-direction: column;
  flex: 1;
}

.Insights .Insights__title {
  font-family: "Roboto";
  font-size: 0.79rem;
  line-height: 1.82;
  color: var(--palette-gray-8);
}

.Insights .Insights__value {
  font-family: "Roboto";
  font-size: 0.93rem;
  line-height: 1.5;
  color: var(--palette-text);
}

.Insights .Insights__install_pixel {
  margin-top: 10px;
  font-size: 0.79rem;
}

.Insights .Insights__main_description {
  font-family: "Roboto";
  font-size: 1rem;
  line-height: 1.43;
  color: var(--palette-gray-8);
}

.Insights .Insights__segmentation_container {
  border-right: 1px solid var(--palette-disabled);
}

.Insights .Insights__install_pixel a {
  color: var(--palette-trovit-blue);
}
`, "",{"version":3,"sources":["webpack://./js/components/UnifiedCampaignForm/TargetingForm/Insights/Insights.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".Insights {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n}\n\n.Insights__volume_history_title,\n.Insights__conversion_history_title {\n  background-color: var(--palette-whipe);\n  padding: 4px 7px;\n  font-family: Roboto;\n  font-size: 0.79rem;\n  line-height: 1.82;\n  color: var(--palette-text);\n  margin: 7px 0px;\n}\n\n.Insights__volume_history,\n.Insights__conversion_history {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Insights__cpc_history,\n.Insights__clicks_history {\n  flex-direction: column;\n}\n\n.Insights__cpc_history {\n  flex: 2;\n}\n\n.Insights__clicks_history {\n  flex: 1;\n}\n\n.Insights__conversion_history {\n  display: flex;\n}\n\n.Insights__conversion_rate,\n.Insights__average_cpa,\n.Insights__conversions {\n  flex-direction: column;\n  flex: 1;\n}\n\n.Insights__title {\n  font-family: \"Roboto\";\n  font-size: 0.79rem;\n  line-height: 1.82;\n  color: var(--palette-gray-8);\n}\n\n.Insights__value {\n  font-family: \"Roboto\";\n  font-size: 0.93rem;\n  line-height: 1.5;\n  color: var(--palette-text);\n}\n\n.Insights__install_pixel {\n  margin-top: 10px;\n  font-size: 0.79rem;\n}\n\n.Insights__main_description {\n  font-family: \"Roboto\";\n  font-size: 1rem;\n  line-height: 1.43;\n  color: var(--palette-gray-8);\n}\n\n.Insights__segmentation_container {\n  border-right: 1px solid var(--palette-disabled);\n}\n\n.Insights__install_pixel a {\n  color: var(--palette-trovit-blue);\n}\n\n.Insights .Insights__volume_history_title,\n.Insights .Insights__conversion_history_title {\n  background-color: var(--palette-whipe);\n  padding: 4px 7px;\n  font-family: Roboto;\n  font-size: 0.79rem;\n  line-height: 1.82;\n  color: var(--palette-text);\n  margin: 7px 0px;\n}\n\n.Insights .Insights__volume_history,\n.Insights .Insights__conversion_history {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Insights .Insights__cpc_history,\n.Insights .Insights__clicks_history {\n  flex-direction: column;\n}\n\n.Insights .Insights__cpc_history {\n  flex: 2;\n}\n\n.Insights .Insights__clicks_history {\n  flex: 1;\n}\n\n.Insights .Insights__conversion_history {\n  display: flex;\n}\n\n.Insights .Insights__conversion_rate,\n.Insights .Insights__average_cpa,\n.Insights .Insights__conversions {\n  flex-direction: column;\n  flex: 1;\n}\n\n.Insights .Insights__title {\n  font-family: \"Roboto\";\n  font-size: 0.79rem;\n  line-height: 1.82;\n  color: var(--palette-gray-8);\n}\n\n.Insights .Insights__value {\n  font-family: \"Roboto\";\n  font-size: 0.93rem;\n  line-height: 1.5;\n  color: var(--palette-text);\n}\n\n.Insights .Insights__install_pixel {\n  margin-top: 10px;\n  font-size: 0.79rem;\n}\n\n.Insights .Insights__main_description {\n  font-family: \"Roboto\";\n  font-size: 1rem;\n  line-height: 1.43;\n  color: var(--palette-gray-8);\n}\n\n.Insights .Insights__segmentation_container {\n  border-right: 1px solid var(--palette-disabled);\n}\n\n.Insights .Insights__install_pixel a {\n  color: var(--palette-trovit-blue);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
